<template>
  <router-view/>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  setup() {
    const OriginalResizeObserver = (window as any).ResizeObserver;
    if (OriginalResizeObserver) {
      (window as any).ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
        private cancelPendingCallback: () => void;

        // eslint-disable-next-line no-unused-vars
        constructor(callback: (...args: any[]) => void) {
          let timeoutId: ReturnType<typeof setTimeout> | undefined;

          super((...args: any[]) => {
            if (timeoutId !== undefined) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
              timeoutId = undefined;
              callback(...args);
            }, 20);
          });

          this.cancelPendingCallback = () => {
            if (timeoutId !== undefined) {
              clearTimeout(timeoutId);
              timeoutId = undefined;
            }
          };
        }

        disconnect() {
          this.cancelPendingCallback();
          super.disconnect();
        }

        unobserve(target: Element) {
          this.cancelPendingCallback();
          super.unobserve(target);
        }
      }
    }
  }
});
</script>
